import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../../../../../../App";
import Nodata from "../../../../../../../Reuseable/Nodata";
// import "./AuditionCardReuse.css";

const AuditionJuryMarkedView = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 8;
  const { data, viewResult, viewJuryMark } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      {currentItems.length !== 0 ? (
        <>
          <div className="py-3">
            <div className="row">
              {currentItems.map((event_data) => {
                return (
                  <>
                    <div className="col-md-3 p-3">
                      <div className="card card-bg completedMeetupBlack BlueBorder">
                        <img
                          src={imageCdnUrl+event_data.banner}
                          className="img-fluid p-2 ImgBlue"
                          alt=""
                          style={{
                            height: "200px",
                            width: "100%",
                          }}
                        />
                        <div className="p-3">
                          <center>
                            <h4 className="text-white text-center fw-bolder title-limit">
                              <i>{event_data.title ?? ""}</i>
                            </h4>

                            {viewJuryMark && (
                              <Link to={`${viewJuryMark}/${event_data.slug}`}>
                                {" "}
                                <button className="btn btnEditTest btnTest fw-bold my-2 w-100">
                                  View Jury Marks
                                </button>
                              </Link>
                            )}
                            {viewResult && (
                              <Link to={`${viewResult}/${event_data.slug}`}>
                                {" "}
                                <button className="btn btnConfirm btnTest fw-bold my-2 w-100">
                                  View Results
                                </button>
                              </Link>
                            )}
                          </center>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>

          <div id="react-paginate">
            <ReactPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              breakLinkClassName={"page-link"}
              containerClassName={"pagination"}
              pageLinkClassName={"page-link"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </>
      ) : (
        <Nodata />
      )}
    </>
  );
};

export default AuditionJuryMarkedView;
